function RouteErrorPage(props) {
  throw new Error("error page");
  // return <div>{obj}</div>;
}

export default RouteErrorPage;
